(function($R)
{
  $R.add('plugin', 'handle', {
      init: function(app)
      {
          this.app = app;
          this.opts = app.opts;
          this.$doc = app.$doc;
          this.$body = app.$body;
          this.editor = app.editor;
          this.marker = app.marker;
          this.keycodes = app.keycodes;
          this.container = app.container;
          this.selection = app.selection;

          // local
          this.handleTrigger = (typeof this.opts.handleTrigger !== 'undefined') ? this.opts.handleTrigger : '@';
          this.handleStart = (typeof this.opts.handleStart !== 'undefined') ? this.opts.handleStart : 0;
          this.handleStr = '';
          this.handleLen = this.handleStart;
      },
      // public
      start: function()
      {
          if (!this.opts.handle) return;

          this._pastedRecently = false;

          var $editor = this.editor.getElement();
    $editor.on('keyup.redactor-plugin-handle', this._handle.bind(this));
          $editor.on('keydown.redactor-plugin-handle', this._listen.bind(this));

          // Suppress autocomplete after paste — pasted @usernames are already
          // complete and will be linked server-side. Without this, the keyup
          // from Ctrl+V triggers the dropdown for the last pasted mention, and
          // if the user submits before selecting, that mention won't be linked.
          $editor.on('paste.redactor-plugin-handle', function() {
              this._pastedRecently = true;
              this._hideForce();
              setTimeout(function() {
                  this._pastedRecently = false;
              }.bind(this), 500);
          }.bind(this));
  },
  stop: function()
  {
          var $editor = this.editor.getElement();

    $editor.off('.redactor-plugin-handle');
          this.$doc.off('.redactor-plugin-handle');

          var $list = $R.dom('#redactor-handle-list');
          $list.remove();
  },

  // private
  _handle: function(e)
  {
      var key = e.which;
    var ctrl = e.ctrlKey || e.metaKey;
    var arrows = [37, 38, 39, 40];

    if (key === this.keycodes.DELETE
        || key === this.keycodes.ESC
        || key === this.keycodes.SHIFT
        || ctrl
        || (arrows.indexOf(key) !== -1)
        || this._pastedRecently
    )
    {
      return;
    }

          // Dynamically extract the text between the last @ and the caret
          // instead of relying on a keystroke counter
          var textBeforeCaret = this.selection.getTextBeforeCaret(50);
          if (!textBeforeCaret) {
              this._hideForce();
              return;
          }

          var triggerIndex = textBeforeCaret.lastIndexOf(this.handleTrigger);
          if (triggerIndex === -1) {
              this._hideForce();
              return;
          }

          // Only trigger if @ is at start or preceded by whitespace
          if (triggerIndex > 0) {
              var charBefore = textBeforeCaret.charAt(triggerIndex - 1);
              if (charBefore && !/\s/.test(charBefore)) {
                  this._hideForce();
                  return;
              }
          }

          var searchStr = textBeforeCaret.substring(triggerIndex + 1);

          // Don't trigger if there's a space in the search string (mention ended)
          if (/\s/.test(searchStr)) {
              this._hideForce();
              return;
          }

          // Update handleStr and handleLen to stay in sync
          this.handleStr = searchStr;
          this.handleLen = searchStr.length;

          if (this.handleLen >= this.handleStart) {
              this._load();
          } else {
              this._hideForce();
          }
  },
      _listen: function(e) {
          var key = e.which;
          var ks = this.keycodes;

          // listen enter
          if (this._isShown() && key === ks.ENTER) {
              var $item = this._getActiveItem();
              if ($item.length === 0) {
                  this._hideForce();
                  return;
              }
              else {
                  e.preventDefault();
                  this._replace(e, $item);
                  this._hideForce();
                  return;
              }
          }

          // listen down / up
          if (this._isShown() && (key === 40 || key === 38)) {
              e.preventDefault();

              var $item = this._getActiveItem();
              if ($item.length === 0) {
                  var $first = this._getFirstItem();
                  this._setActive($first);
              }
              // down
              else if (key === 40) {
                  this._setNextActive($item);
              }
              // up
              else if (key === 38) {
                  this._setPrevActive($item);
              }

              return;
          }
      },
      _getItems: function() {
          return this.$list.find('a');
      },
      _getActiveItem: function() {
          return this._getItems().filter(function(node) {
              return $R.dom(node).hasClass('active');
          });
      },
      _getFirstItem: function() {
          return this._getItems().first();
      },
      _getLastItem: function() {
          return this._getItems().last();
      },
      _setActive: function($el) {
          this._getItems().removeClass('active');
          $el.addClass('active');

          var itemHeight = $el.outerHeight();
          var itemTop = $el.position().top;
          var itemsScrollTop = this.$list.scrollTop();
          var scrollTop = itemTop + itemHeight * 2;
          var itemsHeight = this.$list.outerHeight();

          this.$list.scrollTop(
              scrollTop > itemsScrollTop + itemsHeight ? scrollTop - itemsHeight :
                  itemTop - itemHeight < itemsScrollTop ? itemTop - itemHeight :
                  itemsScrollTop
          );
      },
      _setNextActive: function($el) {
          var $next = $el.next();
          if ($next.length !== 0) {
              this._setActive($next);
          }
          else {
              var $first = this._getFirstItem();
              this._setActive($first);
          }
      },
      _setPrevActive: function($el) {
          var $prev = $el.prev();
          if ($prev.length !== 0) {
              this._setActive($prev);
          }
          else {
              var $last = this._getLastItem();
              this._setActive($last);
          }
      },
  _load: function()
  {
      $R.ajax.post({
          url: this.opts.handle,
          data: 'handle=' + this.handleStr,
          success: this._parse.bind(this)
      });
  },
  _parse: function(json)
  {
      if (json === '') return;

          var data = (typeof json === 'object') ? json : JSON.parse(json);

          this._build();
          this._buildData(data);
  },
  _build: function()
  {
          this.$list = $R.dom('#redactor-handle-list');
          if (this.$list.length === 0)
          {
              this.$list = $R.dom('<div id="redactor-handle-list">');
              this.$body.append(this.$list);
          }
      },
      _buildData: function(data)
      {
          this.data = data;

          this._update();
          this._show();
      },
      _update: function()
      {
          this.$list.html('');

          for (var key in this.data)
          {
              var $item = $R.dom('<a href="#">');
              $item.html(this.data[key].item);
              $item.attr('data-key', key);
              $item.on('click', this._replace.bind(this));

              this.$list.append($item);
          }

          // position
      var $container = this.container.getElement();
          var containerOffset = $container.offset();
          var pos = this.selection.getPosition();

          this.$list.addClass('open');
          this.$list.css({
              top: (pos.top + pos.height + this.$doc.scrollTop()) + 'px',
              left: pos.left + 'px'
          });
      },
      _isShown: function()
      {
          return (this.$list && this.$list.hasClass('open'));
      },
      _show: function()
      {
          this.$list.addClass('open');
          this.$list.show();

          this.$doc.off('.redactor-plugin-handle');
          this.$doc.on('click.redactor-plugin-handle keydown.redactor-plugin-handle', this._hide.bind(this));
      },
      _hide: function(e)
      {
          var hidable = false;
          var key = (e && e.which);

          if (!e) hidable = true;
          else if (e.type === 'click' || key === this.keycodes.ESC || key === this.keycodes.SPACE) hidable = true;

          if (hidable) {
             this._hideForce();
          }
      },
      _hideForce: function() {
          this.$list.removeClass('open');
          this.$list.hide();
          this._reset();
      },
      _reset: function()
      {
          this.handleStr = '';
          this.handleLen = this.handleStart;
      }
  // _replace is defined via prototype override in redactor_main.js
  // to handle both click and keyboard Enter with proper null-guards
  });

})(Redactor);